// import "./trackkflow.css";
// const TrackkPopup = ({ isOpen, onClose }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="popup-overlay">
//       <button className="close-btn" onClick={onClose}>
//         ✖
//       </button>

//       <img
//         // src="/trackkbackground.png"
//         src="/trackkbackgroundnew.png"
//         alt="Trackk"
//         className="popup-image"
//       />
//     </div>
//   );
// };

// export default TrackkPopup;

import "./trackkflow.css";

const TrackkPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>

        <img
          // src="/trackkbackgroundnew.png"
          src="./trackkbackgroundnew.png"
          alt="Trackk"
          className="popup-image"
        />
      </div>
    </div>
  );
};

export default TrackkPopup;
